export default __webpack_public_path__ + "static/media/andre.fde63197.jpg";